export default __webpack_public_path__ + "static/media/Digital Keys.eff11599.svg";